import * as constants from './constants';

export const setTenantDetailsIsEdit = (data) => {
  return {
    type: constants.TENANT_DETAILS_IS_EDIT,
    data: data,
  };
};

export const createTenant = (data) => {
  return {
    type: constants.CREATE_TENANT,
    data: data,
  };
};

export const createTenantSuccess = (data) => {
  return {
    type: constants.CREATE_TENANT_SUCCESS,
    data: data,
  };
};

export const createTenantError = () => {
  return {
    type: constants.CREATE_TENANT_ERROR,
  };
};

export const fetchTenant = (data) => {
  return {
    type: constants.FETCH_TENANT,
    data: data,
  };
};

export const fetchTenantSuccess = (data) => {
  return {
    type: constants.FETCH_TENANT_SUCCESS,
    data,
  };
};

export const fetchTenantError = () => {
  return {
    type: constants.FETCH_TENANT_ERROR,
  };
};

export const updateTenant = (data) => {
  return {
    type: constants.UPDATE_TENANT,
    data: data,
  };
};

export const updateTenantSuccess = (data) => {
  return {
    type: constants.UPDATE_TENANT_SUCCESS,
    data: data,
  };
};

export const updateTenantError = () => {
  return {
    type: constants.UPDATE_TENANT_ERROR,
  };
};

export const fetchTenantDetailsUtils = () => {
  return {
    type: constants.FETCH_TENANTS_UTIL_DATA,
  };
};

export const fetchTenantDetailsUtilsSuccess = (data) => {
  return {
    type: constants.FETCH_TENANTS_UTIL_DATA_SUCCESS,
    data,
  };
};

export const fetchAllTenants = (data) => {
  return {
    type: constants.FETCH_ALL_TENANTS,
    data,
  };
};

export const fetchAllTenantsSuccess = (data) => {
  return {
    type: constants.FETCH_ALL_TENANTS_SUCCESS,
    data,
  };
};
export const fetchAllTenantsError = (data) => {
  return {
    type: constants.FETCH_ALL_TENANTS_ERROR,
    data,
  };
};
export const deleteTenant = (data) => {
  return {
    type: constants.DELETE_TENANT,
    data,
  };
};

export const deleteTenantSuccess = (data) => {
  return {
    type: constants.DELETE_TENANT_SUCCESS,
    data,
  };
};

export const deleteTenantError = (data) => {
  return {
    type: constants.DELETE_TENANT_ERROR,
    data,
  };
};

export const deleteTenantAttach = (data) => {
  return {
    type: constants.DELETE_TENANT_ATTACH,
    data,
  };
};

export const deleteTenantAttachSuccess = (data) => {
  return {
    type: constants.DELETE_TENANT_ATTACH_SUCCESS,
    data,
  };
};

export const deleteTenantAttachError = (data) => {
  return {
    type: constants.DELETE_TENANT_ATTACH_ERROR,
    data,
  };
};

export const tenantDetailCleanupFunc = () => {
  return {
    type: constants.TENANT_DETAIL_CLEANUP_FUNC,
  };
};

export const setTenantNotificationIsEdit = (data) => {
  return {
    type: constants.TENANT_NOTIF_IS_EDIT,
    data: data,
  };
};

export const updateTenantNotifications = (data) => {
  return {
    type: constants.UPDATE_TENANT_NOTIFICATION,
    data: data,
  };
};

export const updateTenantNotificationsSuccess = (data) => {
  return {
    type: constants.UPDATE_TENANT_NOTIFICATION_SUCCESS,
    data: data,
  };
};

export const updateTenantNotificationsError = () => {
  return {
    type: constants.UPDATE_TENANT_NOTIFICATION_ERROR,
  };
};

export const setStorage = (data) => {
  return {
    type: constants.SET_TENANTS_MANAGER_STATE,
    data,
  };
};
